import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import '../../styles/common/LanguageSwitcher.css';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLanguage = i18n.language === 'fr' ? 'en' : 'fr';
        i18n.changeLanguage(newLanguage);
    };

    const getNextLanguageFlag = () => {
        return i18n.language === 'fr' ? '🇺🇸' : '🇫🇷';
    };

    const getNextLanguageText = () => {
        return i18n.language === 'fr' ? 'English' : 'Français';
    };

    return (
        <Button 
            type="text" 
            className="language-switcher-toggle"
            onClick={toggleLanguage}
            title={`Switch to ${getNextLanguageText()}`}
        >
            <span className="next-flag">{getNextLanguageFlag()}</span>
        </Button>
    );
};

export default LanguageSwitcher; 